import { Button, Flex, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { useAuthContext } from "../lib/authentication/components/useAuthContext";

import { artesianTokenErrorModalRef } from "./artesianTokenErrorModalRef";
import { ChackraUIBaseModal } from "./chackraModal/chackraBaseModal";

export const ArtesianTokenErrorModal: React.FC = () => {
  const { context: authProvider } = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);

  // Set up global reference for modal trigger
  useEffect(() => {
    artesianTokenErrorModalRef.show = () => {
      setIsOpen(true);
    };
    return () => {
      artesianTokenErrorModalRef.show = null;
    };
  }, []);

  const handleLogout = async () => {
    setIsOpen(false);
    
    // Clean up MSAL and authentication related localStorage items
    const keysToRemove = [
      'msal.interaction.status',
      'arkTokenExpiry',
      'arkTokenExpiryReadable',
      'selectedTenant'
    ];
    
    // Remove specific keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    // Remove any MSAL cache entries (they start with specific prefixes)
    const allKeys = Object.keys(localStorage);
    allKeys.forEach(key => {
      if (key.startsWith('msal.') || 
          key.startsWith('msal-') || 
          key.includes('msal') ||
          key.includes('token') ||
          key.includes('auth')) {
        localStorage.removeItem(key);
      }
    });
    
    try {
      await authProvider.logout();
    } catch (e) {
      console.error("Logout failed:", e);
    }
  };

  return (
    <ChackraUIBaseModal
      open={isOpen}
      title="Authentication Error"
      unclosable
      size="sm"
      body={
        <Flex direction="column" gap={4} align="center">
          <Text textAlign="center" fontSize="sm" color="fg.muted">
            Unable to authenticate with the Artesian service.
            <br />
            Please log out and try again.
          </Text>

          <Flex gap={3}>
            <Button
              onClick={handleLogout}
              colorScheme="red"
              size="md"
              px={8}
            >
              Logout
            </Button>
          </Flex>
        </Flex>
      }
    />
  );
};
